export const Monogram = ({ size = 40, className = "", testId = "monogram" }) => (
  <img src="/media/monogram.png" alt="Y & S monogram" width={size} height={size} data-testid={testId}
    className={`select-none object-contain ${className}`} style={{ width: size, height: size }} draggable={false} />
);
